module.exports = __webpack_public_path__ + "static/img/loading.90eb470.gif";


//////////////////
// WEBPACK FOOTER
// ./static/gamega.me/loading.gif
// module id = pcGK
// module chunks = 1